import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from './AuthContext';

// Empêche l'indexation des pages privées
export const useNoIndex = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
};

const ProtectedRoute = ({ allow, children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  useNoIndex();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-950" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 animate-spin text-red-600" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/connexion" state={{ from: location }} replace />;
  }

  if (allow && !allow.includes(user.role)) {
    // Rediriger vers l'espace correspondant au rôle
    const target = user.role === 'admin' ? '/admin' : user.role === 'technicien' ? '/technicien' : '/espace-client';
    return <Navigate to={target} replace />;
  }

  return children;
};

export default ProtectedRoute;
